import { jsx as _jsx } from "react/jsx-runtime";
import { ThemeProvider, StyledEngineProvider } from '@mui/material';
import RepeatMarketingTheme from '@themes/RepeatMarketingTheme';
import WithdrawalOnlySiteLandingPage from './WithdrawalOnlySiteLandingPage';
const WithdrawalOnlyLandingPageScreen = () => {
    return (_jsx(StyledEngineProvider, { injectFirst: true, children: _jsx(ThemeProvider, { theme: RepeatMarketingTheme, children: _jsx(WithdrawalOnlySiteLandingPage, {}) }) }));
};
export default WithdrawalOnlyLandingPageScreen;
